import { Component, OnInit, Input } from '@angular/core';

import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() expanded = false;
  sections = [];

  constructor(private authenticationService: AuthenticationService) {
    this.sections = [];

    this.sections = this.sections.concat([
      // { name: 'Dashboard', icon: 'fas fa-tachometer-alt', menu: 'top', type: 'link', url: '/dashboard' },
      { name: 'Queue', icon: 'fas fa-tasks', menu: 'top', type: 'link', url: '/queue' },
      // { name: 'Performance', icon: 'fas fa-chart-line', menu: 'top', type: 'link', url: '/performance' },
      // { name: 'Labs', icon: 'fas fa-flask', menu: 'top', type: 'link', url: '/labs' },
      // { name: 'Prescriptions', icon: 'fas fa-prescription-bottle', menu: 'top', type: 'link', url: '/prescriptions' },
      { name: 'Past Visits', icon: 'fas fa-clock', menu: 'top', type: 'link', url: '/visits' }
    ]);
  }

  ngOnInit() { }

  isLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts